
import Vue from 'vue'

export default Vue.extend({
  name: 'ProfilePlusSvg',
  props: {
    color: {
      required: false,
      default: 'currentColor',
      type: String,
    },
  },
})
